/**
 * Login Action Types and Constants
 *
 * Defines all Redux action type constants for the login module.
 * LOGIN_KEY is loaded from environment variables via the centralized encryption-keys module.
 *
 * SECURITY FIX (#54): LOGIN_KEY now reads from REACT_APP_LOGIN_KEY env variable
 * with a fallback to the default value. This prevents the key from being
 * hardcoded directly in the types file.
 */
import { LOGIN_ENCRYPTION_KEY } from '../_common/encryption-keys';

const LoginTypes = {
	LOGIN_START: 'login_start',
	LOGIN_SUCCESS: 'login_success',
	LOGIN_FAILURE: 'login_failure',
	LOGIN_RESPONSE_CHANGED: 'login_response_changed',
	LOGIN_RESPONSE_REST_START: 'login_response_rest_start',
	PERSIST_LOGIN_DATA_START: 'persist_login_data_start',
	/** SECURITY FIX: New action type for proper logout with storage cleanup */
	LOGOUT: 'logout',
	/** SECURITY FIX (#54): Key loaded from env variable with fallback */
	LOGIN_KEY: LOGIN_ENCRYPTION_KEY,
} as const;

export default LoginTypes;
